import { useEffect, useState } from "react";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORAGE_KEY = "studygri_utm";

/**
 * Reads UTM params from URL on mount, persists them in sessionStorage,
 * and returns them so they can be attached to lead POST bodies.
 * If URL has no UTM but sessionStorage does — restores from storage
 * (so UTMs survive if user navigates between pages before submitting).
 */
export default function useUTM() {
  const [utm, setUtm] = useState({
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_content: "",
    utm_term: "",
  });

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const fromUrl = {};
      let anyFromUrl = false;
      UTM_KEYS.forEach((k) => {
        const v = params.get(k);
        if (v) {
          fromUrl[k] = v;
          anyFromUrl = true;
        }
      });

      if (anyFromUrl) {
        const merged = { ...utm, ...fromUrl };
        setUtm(merged);
        try {
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
        } catch { /* ignore quota / disabled storage */ }
        return;
      }

      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        setUtm((prev) => ({ ...prev, ...parsed }));
      }
    } catch { /* ignore parse / access errors */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return utm;
}
